import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type ToggleActivePayload = {
  id: EntityId
}

export const toggleWebAdminStatus = createAsyncThunk('webAdmins/toggleActive', async ({ id }: ToggleActivePayload) => {
  const results = await OLMSApiService.post<number>('/webAdmin/toggleActive', id)

  return results
})